export default function initTopHeroVideo() {
	const video = document.getElementById('topHeroVideo');
	if (!video) {
		return;
	}

	const source = video.querySelector('source');
	if (!source) {
		return;
	}

	const mq = window.matchMedia('(min-width: 768px)');

	const updateSource = (isDesktop) => {
		const nextSrc = isDesktop
			? '/movie/kv_pc_0416_1_fix.webm'
			: '/movie/kv_sp_0416_1_fix.webm';

		if (source.getAttribute('src') === nextSrc) {
			return;
		}

		source.setAttribute('src', nextSrc);
		video.load();
	};

	updateSource(mq.matches);

	if (typeof mq.addEventListener === 'function') {
		mq.addEventListener('change', (event) => {
			updateSource(event.matches);
		});
	} else {
		mq.addListener((event) => {
			updateSource(event.matches);
		});
	}
}